<div class="container_upload_processing">
    <mat-stepper class="stepper_upload_processing" #stepper [selectedIndex]="0">
        <mat-step label="{{'common.update'|translate }}"></mat-step>
        <mat-step class="h-100" label="{{'import.match'|translate}}">
            <div class="container">
                <div class="quote_timeline">
                    <div class="timeline">
                        <div class="head">
                            <div class="top">
                                <div class="left_title">
                                    <div class="title">
                                        <h3 class="m-0"><strong>{{"common.imported_file"| translate }}</strong></h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="file_upload">
                            <div class="file">
                                <img src="assets/icones/xls.svg" alt="">
                                <span>{{file_name}}</span>
                            </div>
                            <div class="field category_field">
                                <label for="sheet">{{"common.sheet" | translate}}</label>
                                <mat-form-field appearance="fill" style="width: 100%;">
                                    <mat-label>{{"common.sheet" | translate}}</mat-label>
                                    <mat-select id="sheet" [(ngModel)]="selectedSheet">
                                        <mat-option *ngFor="let sheet of responseMatching?.data?.sheets"
                                            [value]="sheet">
                                            {{sheet}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="field category_field">
                                <label for="format">{{ 'import.numeric_format' | translate }}</label>
                                <select id="format" style="width: 100%;" [(ngModel)]="decimal_separator">
                                    <option selected value="EU">{{ 'import.eu' | translate }}</option>
                                    <option value="US">{{ 'import.us' | translate }}</option>
                                </select>
                            </div>
                            <div class="hearder_card">
                                <mat-slide-toggle [checked]="true" [disabled]="true"></mat-slide-toggle>
                                <span>{{"common.use_first_row_as_header"| translate}}</span>
                            </div>
                            <div class="colomns" *ngIf="responseMatching">
                                <ul style="width: 90%;margin: 0 auto;">
                                    <li>{{responseMatching!.data!.columns.length}} : {{"common.total_colomns"|
                                        translate}}</li>
                                    <li><span></span>{{missedColomns(responseMatching!.data!.columns, selectedValues)}}
                                        : {{"common.missed_colomns"| translate}}</li>
                                </ul>
                                <div class="td_inline" style="margin-top: 10px;">
                                    <mat-progress-bar class="example-margin audio-progress-bar" [mode]="mode"
                                        [value]="selectedColomnsPercentage(responseMatching!.data!.columns, selectedValues)">
                                    </mat-progress-bar>
                                    <span
                                        style="text-wrap: nowrap;">{{selectedColomnsPercentage(responseMatching!.data!.columns,
                                        selectedValues).toFixed(2)}}%</span>
                                </div>
                            </div>
                            <div class="field category_field colomns">
                                <b>{{"common.help"| translate}}</b>
                                <div class="content_card">
                                    <img src="assets/icones/hint.svg" alt="">
                                    <span class="light">{{ '---' }}</span>
                                </div>
                            </div>
                            <div class="foter_buttons">
                                <button type="button" class="save_btn_pop_up blue_btn" data-testid="import-match-next" (click)="testAndResolve()">
                                    <span> {{"common.test_and_resolve_error"| translate}}</span>
                                    <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
                                </button>
                                <button type="button" class="save_btn_pop_up cancel_btn_pop_up" (click)="back()">
                                    <span>{{"common.cancel"| translate}}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right_container" *ngIf="responseMatching as response">
                    <div class="error_message" *ngIf="matchingErrorsResponse">
                        {{matchingErrorsResponse.messages[0].message}}</div>
                    <div class="matching_listing_table_container">
                        <table class="matching_listing_table">
                            <thead class="header_stiky">
                                <tr class="head_table">
                                    <th>{{"import.file_column"| translate}}</th>
                                    <th class="alert_td"></th>
                                    <th>{{"import.wolsal_column"| translate}}</th>
                                    <th>{{"import.comment"| translate}}</th>
                                </tr>
                            </thead>
                            <tbody class="scrollable_body_import">
                                <tr class="body_table hover_tr"
                                    [attr.data-testid]="'import-column-row-' + i"
                                    *ngFor="let item of response.data.columns; let i = index">
                                    <td class="td_block">
                                        <span class="bold">{{ item }}</span>
                                    </td>
                                    <td class="alert_td">
                                        <img *ngIf="!selectedValues[i]"
                                            src="../../../../../assets/icones/low-warning.svg" alt=""
                                            style="margin-right: 10px;">
                                    </td>
                                    <td>
                                        <select *ngIf="selectedValues[i]" style="width: 90%; font-size: 14px;"
                                            [attr.data-testid]="'import-column-select-' + i"
                                            [(ngModel)]="selectedValues[i]" (change)="setSelectedValue(i, $event)">
                                            <option selected value=""></option>
                                            <option *ngFor="let item of response.data.fields" [value]="item.name">
                                                {{ "import.product_fields." + item.id | translate }}
                                            </option>
                                        </select>
                                        <select *ngIf="!selectedValues[i]" style="width: 90%; font-size: 14px;"
                                            [attr.data-testid]="'import-column-select-' + i"
                                            [(ngModel)]="selectedValues[i]" (change)="setSelectedValue(i, $event)">
                                            <option selected value=""></option>
                                            <option *ngFor="let item of filteredFields" [value]="item.name">
                                                {{item.string}}
                                            </option>
                                        </select>
                                    </td>
                                    <td>
                                        <!-- <div class="content_card">
                                                <img src="assets/icones/hint.svg" alt="">
                                                <span class="light">{{ '---' }}</span>
                                            </div> -->
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </mat-step>
        <mat-step label="{{'import.test'|translate}}">
            <div class="container">
                <div class="quote_timeline">
                    <div class="timeline">
                        <div class="head">
                            <div class="top">
                                <div class="left_title">
                                    <div class="title">
                                        <h3 class="m-0"><strong>{{"common.imported_file"| translate}}</strong></h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="file_upload">
                            <div class="file">
                                <img src="assets/icones/xls.svg" alt="">
                                <span>{{file_name}}</span>
                            </div>
                            <div class="field category_field">
                                <label for="sheet">{{"common.sheet" | translate}}</label>
                                <mat-form-field appearance="fill" style="width: 100%;">
                                    <mat-label>{{"common.sheet" | translate}}</mat-label>
                                    <mat-select id="sheet" [(ngModel)]="selectedSheet">
                                        <mat-option *ngFor="let sheet of responseMatching?.data?.sheets"
                                            [value]="sheet">
                                            {{sheet}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="field category_field">
                                <label for="format">{{ 'import.numeric_format' | translate }}</label>
                                <select id="format" style="width: 100%;" [(ngModel)]="decimal_separator">
                                    <option selected value="EU">{{ 'import.eu' | translate }}</option>
                                    <option value="US">{{ 'import.us' | translate }}</option>
                                </select>
                            </div>
                            <div class="hearder_card">
                                <mat-slide-toggle [checked]="true" [disabled]="true"></mat-slide-toggle>
                                <span>{{"common.use_first_row_as_header"|translate}}</span>
                            </div>
                            <div class="colomns" *ngIf="responseMatching">
                                <ul style="width: 90%;margin: 0 auto; ">
                                    <li><span></span>{{responseMatching!.data!.columns.length}} :
                                        {{"common.total_colomns"| translate}}</li>
                                    <li><span></span>{{missedColomns(responseMatching!.data!.columns, selectedValues)}}
                                        : {{"common.missed_colomns" | translate}}</li>
                                    <!-- <li><span></span>--- : ---</li> -->
                                </ul>
                                <div class="td_inline" style="margin-top: 10px;">
                                    <mat-progress-bar class="example-margin audio-progress-bar" [mode]="mode"
                                        [value]="selectedColomnsPercentage(responseMatching!.data!.columns, selectedValues)">
                                    </mat-progress-bar>
                                    <span
                                        style="text-wrap: nowrap;">{{selectedColomnsPercentage(responseMatching!.data!.columns,
                                        selectedValues).toFixed(2)}}%</span>
                                </div>
                            </div>
                            <div class="field category_field colomns">
                                <b>{{"common.help"|translate}}</b>
                                <div class="content_card">
                                    <img src="assets/icones/hint.svg" alt="">
                                    <span class="light">{{ '---' }}</span>
                                </div>
                            </div>
                            <div class="foter_buttons" *ngIf="true">
                                <label for="myfile" class="save_btn_pop_up blue_btn label_input"
                                    *ngIf="rowsErrorsResponse">
                                    <span>{{"import.re_import_file"| translate}}</span>
                                    <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
                                </label>
                                <input type="file" id="myfile" class="input_file" (change)="reaploadFile($event)">
                                <button type="button" class="save_btn_pop_up blue_btn" (click)="testAndResolve()"
                                    data-testid="import-test-retry"
                                    *ngIf="rowsErrorsResponse">
                                    <span>{{"common.test_and_resolve_error"|translate}}</span>
                                    <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
                                </button>
                                <button type="button" class="save_btn_pop_up blue_btn" (click)="stepper.next()"
                                    data-testid="import-preview-next"
                                    *ngIf="!rowsErrorsResponse">
                                    <span>{{"common.preview"|translate}}</span>
                                </button>
                                <button type="button" class="save_btn_pop_up cancel_btn_pop_up"
                                    (click)="stepper.previous()" *ngIf="rowsErrorsResponse">
                                    <span>{{"common.back"|translate | uppercase}}</span>
                                    <img alt="" src="../../../../../assets/icones/arrow_back.svg">
                                </button>
                                <button type="button" class="save_btn_pop_up cancel_btn_pop_up" (click)="back()">
                                    <span>{{"common.cancel"|translate}}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right_container">
                    <div class="check_to_imported_file" *ngIf="!rowsErrorsResponse">
                        <img src="assets/icones/succsess.svg" alt="">
                        <span>{{"import.congrat_your_file"|translate}}<br />
                            {{"import.imported_there"|translate}}</span>
                    </div>
                    <div *ngIf="rowsErrorsResponse" class="matching_listing_table_container">
                        <table class="matching_listing_table">
                            <thead class="header_stiky">
                                <tr class="head_third_step">
                                    <th>{{"import.error_type"| translate}}</th>
                                    <th>{{"import.error_line"| translate}}</th>
                                    <th>{{"common.description"| translate}}</th>
                                    <th>{{"import.solution"| translate }}</th>
                                    <th>{{"import.view_line_content"| translate}}</th>
                                </tr>
                            </thead>
                            <tbody class="scrollable_body_import">
                                <tr class="body_third_step body_table hover_tr"
                                    data-testid="import-error-row"
                                    *ngFor="let error of rowsErrorsResponse.messages">
                                    <td class="td_block">
                                        <span class="tag">{{ error.type }}</span>
                                    </td>
                                    <td class="td_block">
                                        <span class="bold" *ngIf="error.rows">{{ error.rows.from + 2}}</span>
                                    </td>
                                    <td>
                                        <span *ngIf="error.message" class="bold">{{ error.message}}</span>
                                        <div *ngIf="error.messages" class="bold">
                                            <ul>
                                                <li *ngFor="let item of error.messages | slice:0:3">{{ item }}</li>
                                                <span class="and_more" *ngIf="error.messages.length > 3">and {{
                                                    error.messages.length - 3 }} more</span>
                                            </ul>
                                        </div>
                                    </td>
                                    <td>
                                        <div *ngIf="!isRelationError(error.field)">
                                            <img src="assets/icones/hint.svg" alt="" style="margin-right: 5px;">
                                            <span>{{"import.modify_field_hint" | translate: {error_field: error.field }
                                                }}</span>
                                        </div>
                                        <select *ngIf="isRelationError(error.field)"
                                            style="width: 90%; font-size: 14px;" (change)="setSolution(error, $event)">
                                            <option value="prevent">{{"import.prevent_import"|translate}}</option>
                                            <option value="create_new_values">{{"import.create_new_values"|translate}}
                                            </option>
                                        </select>
                                    </td>
                                    <td>
                                        <div class="td_inline view_content"
                                            data-testid="import-error-view-btn"
                                            (click)="viewErrorContent(error, rowsErrorsResponse)">
                                            <img src="assets/icones/eye.svg" alt="">
                                            <span class="light" style="text-wrap: nowrap;font-size: smaller;">
                                                {{"import.view_content"| translate}}</span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </mat-step>
        <mat-step label="{{'common.preview'|translate }}">
            <div class="preview_container" *ngIf="productsImport.length > 0">
                <div class="table_products">
                    <div class="header_preview">
                        <h2>{{ productsImport.length}} {{"Catalogs.products_included"| translate}}</h2>
                    </div>
                    <div class="page_container">
                        <table class="listing_table preview">
                            <thead class="header_stiky">
                                <tr class="head_preview">
                                    <th>{{"common.image"| translate}}</th>
                                    <th>{{"common.name"| translate}} <br> {{"inventory.sku"|translate}}</th>
                                    <th>{{"common.description"| translate}}</th>
                                    <th class="number_clmn">{{"import.stock"|translate}}</th>
                                    <th>{{"import.brand_import"| translate}}</th>
                                    <th>{{"import.category_import"| translate}}</th>
                                    <th class="number_clmn">{{"import.cost"|translate}}</th>
                                    <th class="number_clmn">{{"Catalogs.retail_price"|translate}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let product of productsImport">
                                    <tr class="body_preview hover_tr">
                                        <td class="first_td">
                                            <img *ngIf="product[getFieldIndex('image_1920')]" class="listing_image"
                                                src="{{product[getFieldIndex('image_1920')]}}" alt="">
                                            <img *ngIf="!product[getFieldIndex('image_1920')]" class="listing_image"
                                                src="assets/icones/no-image.png" alt="">
                                        </td>
                                        <td class="description_cell td_block cursor">
                                            <span class="descr_elemnt bold_span">{{ product[getFieldIndex('name')]
                                                }}</span><br>
                                            <span class="descr_elemnt light_span">{{ product[getFieldIndex('sku')]
                                                }}</span>
                                        </td>
                                        <td class="td_actions description_cell">
                                            <span class="descr_elemnt"
                                                [innerHTML]="product[getFieldIndex('description')]">
                                            </span>
                                        </td>
                                        <td class="number_clmn">
                                            {{ product[getFieldIndex('product_variant_ids/stock_quants/quantity')]}}
                                        </td>
                                        <td>
                                            {{ product[getFieldIndex('brand_id')] ?? 'N/A' }}
                                        </td>
                                        <td>
                                            {{ product[getFieldIndex('category_ids')] ?? 'N/A' }}
                                        </td>
                                        <td class="number_clmn">{{ product[getFieldIndex('standard_price')]}}</td>
                                        <td class="number_clmn">
                                            {{ product[getFieldIndex('list_price')] }}
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="foter_buttons btns_commit" *ngIf="true">
                    <button type="button" class="action_btn btn_edit" data-testid="import-save-draft-btn" (click)="saveAsDraft()">
                        <mat-icon style="color: #6449DB;">save</mat-icon>
                        <span>{{"common.save"|translate | uppercase}} AS {{"common.draft"| translate}}</span>
                    </button>
                    <button type="button" class="save_btn_pop_up green_btn" data-testid="import-commit-btn" (click)="commit()">
                        <span>{{"common.commit"| translate}}</span>
                        <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
                    </button>
                </div>
            </div>
        </mat-step>
        <mat-step label="{{'common.commit'|translate }}"></mat-step>
    </mat-stepper>
</div>